<template>
  <v-layout class="body-1">
    <strong class="mr-2">
      Active:
      <span class="green--text text--lighten-2">
        {{ active }}
      </span>
    </strong>
    <strong>
      Total:
      <span class="green--text text--lighten-2">
        {{ total }}
      </span>
    </strong>
  </v-layout>
</template>

<script>
export default {
  name: 'UmsApplicationsCount',
  props: {
    apps: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    total() {
      return this.apps.length;
    },
    active() {
      return this.apps.filter(({ state }) => Boolean(state)).length;
    },
  },
};
</script>
